import { render, staticRenderFns } from "./PaymentMode.vue?vue&type=template&id=227f2df3"
import script from "./PaymentMode.vue?vue&type=script&lang=js"
export * from "./PaymentMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports